import { SaiSurveyTerm as Term } from '../../../graphQL';

export const getTermOptions = () => {
  return Object.entries(Term).map(([key, value]) => ({
    id: value,
    label: key,
  }));
};

export const calculateYears = (
  startDate: string,
  term: Term
): { calendarYear: string; academicYearStart: string; academicYearEnd: string } => {
  if (!startDate) return { calendarYear: '', academicYearStart: '', academicYearEnd: '' };

  const calendarYearNum = new Date(startDate).getFullYear();

  let academicYearStartNum = 0;
  let academicYearEndNum = 0;
  if (term === Term.Fall) {
    academicYearStartNum = calendarYearNum;
    academicYearEndNum = calendarYearNum + 1;
  } else if (term === Term.Spring) {
    academicYearStartNum = calendarYearNum - 1;
    academicYearEndNum = calendarYearNum;
  }

  return {
    calendarYear: String(calendarYearNum),
    academicYearStart: academicYearStartNum ? String(academicYearStartNum) : '',
    academicYearEnd: academicYearEndNum ? String(academicYearEndNum) : '',
  };
};

const EASTERN_TIME_ZONE = 'America/New_York';

/** Renders an instant as a survey admin reads it: Eastern, 24-hour, ET-suffixed. */
export const formatEasternTimestamp = (value: string | Date): string | undefined => {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return undefined;

  const formatted = new Intl.DateTimeFormat('en-US', {
    timeZone: EASTERN_TIME_ZONE,
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    // h23, not hour12:false — en-US resolves the latter to h24, which numbers
    // midnight as 24 ("24:30" for 00:30).
    hourCycle: 'h23',
  }).format(date);

  return `${formatted.replace(',', '')} ET`;
};
